import { render, staticRenderFns } from "./OnlineClass.vue?vue&type=template&id=4257adcc&scoped=true&"
import script from "./OnlineClass.vue?vue&type=script&lang=js&"
export * from "./OnlineClass.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClass.vue?vue&type=style&index=0&id=4257adcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4257adcc",
  null
  
)

export default component.exports